import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, ExternalLink } from 'lucide-react';
import { DOFINANSOWANIE } from '../../data/dofinansowanie';
import './Footer.css';

const CONTACT = {
  name: 'Rafloor Elektryka i Teletechnika',
  phone: '+48 512 280 787',
  email: 'rafal.lopatka@rafloor.pl',
  address: 'Mrowino, ul. Dobrowita 34',
  mapsQuery: 'Mrowino ul. Dobrowita 34 62-090',
};

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const mapHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(CONTACT.mapsQuery)}`;

  const quickLinks = [
    { title: 'O firmie', path: '/o-firmie' },
    { title: 'Oferta', path: '/oferta' },
    { title: 'Nasze realizacje', path: '/nasze-realizacje' },
    { title: 'Kontakt', path: '/kontakt' },
  ];

  const services = [
    'Instalacje elektryczne',
    'Systemy teletechniczne',
    'Automatyka przemysłowa',
    'Serwis i konserwacja',
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Kolumna 1 */}
        <div className="footer-section">
          <div className="footer-logo">
            <h3>Rafloor Elektryka i Teletechnika</h3>
            <p>
              Profesjonalne usługi elektryczne i teletechniczne.
              Stawiamy na jakość, terminowość i bezpieczeństwo zgodne z normami.
            </p>
          </div>
        </div>

        {/* Kolumna 2 */}
        <div className="footer-section">
          <h4>Szybkie linki</h4>
          <ul className="footer-links">
            {quickLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path} className="footer-link">
                  {link.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Kolumna 3 */}
        <div className="footer-section">
          <h4>Nasze usługi</h4>
          <ul className="footer-links">
            {services.map((service) => (
              <li key={service}>
                <span className="footer-service">{service}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Kolumna 4 */}
        <div className="footer-section">
          <h4>Kontakt</h4>
          <div className="contact-info">
            <div className="contact-item">
              <span className="contact-icon"><Phone size={18} /></span>
              <a className="contact-value" href={`tel:${CONTACT.phone.replace(/\s+/g, '')}`}>
                {CONTACT.phone}
              </a>
            </div>
            <div className="contact-item">
              <span className="contact-icon"><Mail size={18} /></span>
              <a className="contact-value" href={`mailto:${CONTACT.email}`}>
                {CONTACT.email}
              </a>
            </div>
            <div className="contact-item">
              <span className="contact-icon"><MapPin size={18} /></span>
              <a
                className="contact-value"
                href={mapHref}
                target="_blank"
                rel="noreferrer"
                title="Otwórz w Mapach"
              >
                {CONTACT.address} <ExternalLink size={14} className="ext" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {currentYear} Rafloor Elektryka i Teletechnika. Wszystkie prawa zastrzeżone.</p>
          <Link to={DOFINANSOWANIE.path} className="footer-dofinansowanie">
            <img
              src={DOFINANSOWANIE.znakiRP}
              alt="Barwy Rzeczypospolitej Polskiej i godło Rzeczypospolitej Polskiej"
            />
            <span>Projekt dofinansowany z Funduszu Ubezpieczeń Społecznych</span>
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
